import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Services, News, Learning, Solution } from "./Menu";
import DropDown from "./DropDown";
import Logo from "../../assets/images/logo-1.jpg";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import  yrlogo  from "../../assets/images/icons/7yr-logo.png";
export default function Header({ variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    });
  }, []);

  return (
    <>
      <header
        className={`main-header header__style__one ${
          variant ? variant : ""
        } header__sticky ${isSticky ? "fixed-header" : ""}`}
      >
        <div className="header-top-one">
          <div className="auto-container">
            <div className="top__inner">
              <div className="top__hrader__left">
                <ul>
                  <li>
                    <span>Address :</span> 10 ANSON ROAD, #10-11, INTERNATIONAL
                    PLAZA, SINGAPORE 079903
                  </li>
                  <li>/</li>
                  <li>
                    {/* <span>Email :</span>{" "} */}
                    <Link to="mailto:admin@siw.com">
                      <FontAwesomeIcon
                        style={{ margin: "0 10px", color: "#009999" }}
                        icon={faEnvelope}
                        size="lg"
                      />
                      : admin@siw.sg
                    </Link>
                  </li>
                  <li>
                    {/* <span>Email :</span>{" "} */}
                    <Link to="mailto:admin@siw.com">
                      <FontAwesomeIcon
                        style={{ margin: "0 10px", color: "#009999" }}
                        icon={faPhone}
                        size="lg"
                      />
                      : +65 90059743
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="top__hrader__right">
                <ul>
                  <li>
                    <Link
                      to="https://www.facebook.com/profile.php?id=61559271932769"
                      target="_blank"
                    >
                      <i className="icon-10"></i>
                    </Link>
                  </li>
                  {/* <li><Link to="#"><i className="icon-instagram"></i></Link></li> */}
                  <li>
                    <Link
                      to="https://www.linkedin.com/company/smart-ilab-works/"
                      target="_blank"
                    >
                      <i className="icon-01"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/smart_ilab_works/"
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={faInstagram} size="lg" />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.youtube.com/channel/UC_PV6LzesweJvuDkYIb0AVw"
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={faYoutube} size="lg" />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="header-lower">
          <div className="auto-container">
            <div className="outer-box">
              {/* Experience Badge */}
              <div className="experience-badge">
                {/* <span className="years">
                  7<sup>th</sup> <br></br>
                  <span className="text">YEAR</span>
                </span> */}
                <img src={yrlogo} alt="7 year anniversary logo"></img>
              </div>
              <div className="logo-box">
                <figure className="logo">
                  <Link to="/">
                    <img src={Logo} alt="Logo" />
                  </Link>
                </figure>
              </div>

              <div className="menu-area clearfix">
                <div
                  className={
                    mobileToggle ? "mobile-menu-visible" : "mobile-menus"
                  }
                >
                  <div
                    className="mobile-nav-toggler"
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <i className="icon-bar"></i>
                    <i className="icon-bar"></i>
                    <i className="icon-bar"></i>
                  </div>
                  <div className="mobile-menu">
                    <div className="menu-backdrop"></div>
                    <div
                      className="close-btn"
                      onClick={() => setMobileToggle(!mobileToggle)}
                    >
                      <i className="icon-fa-times"></i>
                    </div>

                    <nav className="menu-box">
                      <div className="nav-logo">
                        {/* <Link to="/"><img src={Logo} alt="" title="" /></Link> */}
                        <h3>Smart iLab Works</h3>
                      </div>
                      <div className="menu-outer">
                        <div
                          className="collapse navbar-collapse show clearfix"
                          id="navbarSupportedContent"
                        >
                          <ul className="navigation clearfix home-menu">
                            <li>
                              <NavLink to="/">Home</NavLink>
                            </li>
                            <li>
                              <NavLink to="/about">About</NavLink>
                            </li>
                            <li className="dropdown">
                              <NavLink to="/services">Services</NavLink>
                              <DropDown>
                                <ul>
                                  <Services />
                                </ul>
                              </DropDown>
                            </li>
                            <li className="dropdown">
                              <a
                                href="/"
                                className="dropdown-trigger"
                                role="button"
                                onClick={(e) => e.preventDefault()}
                              >
                                Solution
                              </a>

                              <DropDown>
                                <ul className="dropdown-solution-menu">
                                  <li
                                    className="dropdown-heading"
                                    style={{
                                      color: "#fff",
                                      fontSize: "20px",
                                      paddingLeft: "25px",
                                    }}
                                  >
                                    AI &amp; RPA
                                  </li>
                                  <Solution />
                                </ul>
                              </DropDown>
                            </li>
                            <li className="dropdown">
                              <a
                                href="/"
                                className="dropdown-trigger"
                                role="button"
                                onClick={(e) => e.preventDefault()}
                              >
                                Training
                              </a>

                              <DropDown>
                                <ul>
                                  <News />
                                </ul>
                              </DropDown>
                            </li>
                            <li className="dropdown">
                              <a
                                href="/"
                                className="dropdown-trigger"
                                role="button"
                                onClick={(e) => e.preventDefault()}
                              >
                                E-Learning
                              </a>
                              <DropDown>
                                <ul>
                                  <Learning />
                                </ul>
                              </DropDown>
                            </li>
                            {/* <li>
                              <NavLink to="https://ai.siw.sg/" target="_blank" rel="noopener noreferrer">
                                AI Resume
                              </NavLink>
                            </li> */}

                            {/* <li className="dropdown" >
                                                            <NavLink to="/projects">Projects</NavLink>

                                                        </li> */}
                            {/* <li className="dropdown">
                              <NavLink to="/blog">Blog</NavLink>
                            </li> */}
                            <li>
                              <NavLink to="/ura-api-Transactions">URA</NavLink>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="contact-info">
                        <h4>Contact Info</h4>
                        <ul>
                          <li>
                            10 ANSON ROAD, #10-11, INTERNATIONAL PLAZA,
                            SINGAPORE 079903
                          </li>
                          <li>
                            <Link to="tel:+6590059743">+65 90059743</Link>
                          </li>
                          <li>
                            <Link to="mailto:info@example.com">
                              admin@siw.sg
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </nav>
                  </div>
                </div>
                <nav className="main-menu navbar-expand-md navbar-light">
                  <div
                    className="collapse navbar-collapse show clearfix"
                    id="navbarSupportedContent"
                  >
                    <ul className="navigation clearfix home-menu">
                      <li>
                        <NavLink to="/">Home</NavLink>
                        {/* <DropDown>
                                                    <ul>
                                                        <Home />
                                                    </ul>
                                                </DropDown> */}
                      </li>
                      <li>
                        <NavLink to="/about">About</NavLink>
                      </li>
                      <li className="dropdown">
                        <NavLink to="/services">Services</NavLink>
                        <DropDown>
                          <ul>
                            <Services />
                          </ul>
                        </DropDown>
                      </li>
                      <li className="dropdown">
                        <a
                          href="/"
                          className="dropdown-trigger"
                          role="button"
                          onClick={(e) => e.preventDefault()}
                        >
                          Solution
                        </a>

                        <DropDown>
                          <ul className="dropdown-solution-menu">
                            <li
                              className="dropdown-heading"
                              style={{
                                color: "#fff",
                                fontSize: "20px",
                                // paddingLeft: "25px",
                              }}
                            >
                              AI &amp; RPA
                            </li>

                            <Solution />
                          </ul>
                        </DropDown>
                      </li>
                      <li className="dropdown">
                        <a
                          href="/"
                          className="dropdown-trigger"
                          role="button"
                          onClick={(e) => e.preventDefault()}
                        >
                          Training
                        </a>

                        <DropDown>
                          <ul>
                            <News />
                          </ul>
                        </DropDown>
                      </li>
                      <li className="dropdown">
                        <a
                          href="/"
                          className="dropdown-trigger"
                          role="button"
                          onClick={(e) => e.preventDefault()}
                        >
                          E-Learning
                        </a>

                        <DropDown>
                          <ul>
                            <Learning />
                          </ul>
                        </DropDown>
                      </li>
                      {/* <li>
                        <NavLink to="https://ai.siw.sg/" target="_blank" rel="noopener noreferrer">
                          AI Resume
                        </NavLink>
                      </li> */}

                      {/* <li className="dropdown" >
                                                            <NavLink to="/projects">Projects</NavLink>

                                                        </li> */}
                      {/* <li className="dropdown">
                        <NavLink to="/blog">Blog</NavLink>
                      </li> */}
                      <li>
                        <NavLink to="/ura-api-Transactions">URA</NavLink>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
              {/* <div className="btn-box">
                <Link to="/contact" className="theme-btn theme-btn-one">
                  <i className="icon-02"></i> Contact
                </Link>
              </div> */}
            </div>
          </div>
        </div>
        <div className="sticky-header">
          <div className="header-top-one">
            <div className="auto-container">
              <div className="top__inner">
                <div className="top__hrader__left">
                  <ul>
                    <li>
                      <span>Address :</span> 10 ANSON ROAD, #10-11,
                      INTERNATIONAL PLAZA, SINGAPORE 079903
                    </li>
                    <li>/</li>
                    <li>
                      {/* <span>Email :</span>{" "} */}
                      <Link to="mailto:admin@siw.com">
                        <FontAwesomeIcon
                          style={{ margin: "0 10px", color: "#009999" }}
                          icon={faEnvelope}
                          size="lg"
                        />
                        : admin@siw.sg
                      </Link>
                    </li>
                    <li>
                      {/* <span>Email :</span>{" "} */}
                      <Link to="mailto:admin@siw.com">
                        <FontAwesomeIcon
                          style={{ margin: "0 10px", color: "#009999" }}
                          icon={faPhone}
                          size="lg"
                        />
                        : +65 90059743
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="top__hrader__right">
                  <ul>
                    <li>
                      <Link
                        to="https://www.facebook.com/profile.php?id=61559271932769"
                        target="_blank"
                      >
                        <i className="icon-10"></i>
                      </Link>
                    </li>
                    {/* <li><Link to="#"><i className="icon-instagram"></i></Link></li> */}
                    <li>
                      <Link
                        to="https://www.linkedin.com/company/smart-ilab-works/"
                        target="_blank"
                      >
                        <i className="icon-01"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://www.instagram.com/smart_ilab_works/"
                        target="_blank"
                      >
                        <FontAwesomeIcon icon={faInstagram} size="lg" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://www.youtube.com/channel/UC_PV6LzesweJvuDkYIb0AVw"
                        target="_blank"
                      >
                        <FontAwesomeIcon icon={faYoutube} size="lg" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="auto-container">
            <div className="outer-box">
              <div className="experience-badge">
                {/* <span className="years">
                  7<sup>th</sup> <br></br>
                  <span className="text">YEAR</span>
                </span> */}
                <img src={yrlogo} alt="7 year anniversary logo"></img>
              </div>
              <div className="logo-box">
                <figure className="logo">
                  <Link to="/">
                    <img src={Logo} alt="" />
                  </Link>
                </figure>
              </div>
              <div className="menu-area clearfix">
                <nav className="main-menu clearfix">
                  <div
                    className="collapse navbar-collapse show clearfix"
                    id="navbarSupportedContent"
                  >
                    <ul className="navigation clearfix home-menu">
                      <li>
                        <NavLink to="/">Home</NavLink>
                        {/* <DropDown>
                                                    <ul>
                                                        <Home />
                                                    </ul>
                                                </DropDown> */}
                      </li>
                      <li>
                        <NavLink to="/about">About</NavLink>
                      </li>
                      <li className="dropdown">
                        <NavLink to="/services">Services</NavLink>
                        <DropDown>
                          <ul>
                            <Services />
                          </ul>
                        </DropDown>
                      </li>
                      <li className="dropdown">
                        <a
                          href="/"
                          className="dropdown-trigger"
                          role="button"
                          onClick={(e) => e.preventDefault()}
                        >
                          Solution
                        </a>
                        <DropDown>
                          <ul className="dropdown-solution-menu">
                            <li
                              className="dropdown-heading"
                              style={{
                                color: "#fff",
                                fontSize: "20px",
                                // paddingLeft: "25px",
                              }}
                            >
                              AI &amp; RPA
                            </li>
                            <Solution />
                          </ul>
                        </DropDown>
                      </li>
                      <li className="dropdown">
                        <a
                          href="/"
                          className="dropdown-trigger"
                          role="button"
                          onClick={(e) => e.preventDefault()}
                        >
                          Training
                        </a>

                        <DropDown>
                          <ul>
                            <News />
                          </ul>
                        </DropDown>
                      </li>
                      <li className="dropdown">
                        <a
                          href="/"
                          className="dropdown-trigger"
                          role="button"
                          onClick={(e) => e.preventDefault()}
                        >
                          E-Learning
                        </a>
                        <DropDown>
                          <ul>
                            <Learning />
                          </ul>
                        </DropDown>
                      </li>
                      {/* <li>
                        <NavLink
                          to="https://ai.siw.sg/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          AI Resume
                        </NavLink>
                      </li> */}

                      {/* <li className="dropdown" >
                                                            <NavLink to="/projects">Projects</NavLink>

                                                        </li> */}
                      {/* <li className="dropdown">
                        <NavLink to="/blog">Blog</NavLink>
                      </li> */}
                      <li>
                        <NavLink to="/ura-api-Transactions">URA</NavLink>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
              {/* <div className="btn-box">
                <Link to="/contact" className="theme-btn theme-btn-one">
                  <i className="icon-02"></i> Contact
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
